import { LeaderGroupCombobox, SalaryGroupCombobox } from '@/components'
import { useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import { InputArea } from './components'

interface UserGroupFieldsProps {
  leaderGroups: string[]
  salaryGroups: string[]
  disabled?: boolean

  onUpdateForm(values: {
    leaderGroups?: string[]
    salaryGroups?: string[]
  }): void
}

/**
 * FD-297: the two group memberships of a user, as multi comboboxes. Rendered as
 * grid areas of the main info card, so it returns a fragment rather than a
 * wrapping element.
 */
export const UserGroupFields: React.FC<UserGroupFieldsProps> = ({
  leaderGroups,
  salaryGroups,
  disabled = false,

  onUpdateForm,
}) => {
  const translations = useTranslate({
    leaderGroups: 'companies.leader-groups',
    salaryGroups: 'salary.salary-groups',
  })

  return (
    <>
      <InputArea $area="leaderGroups">
        <label>{translations.leaderGroups}</label>
        <LeaderGroupCombobox
          mode="multiple"
          value={leaderGroups}
          disabled={disabled}
          onChange={leaderGroups => onUpdateForm({ leaderGroups })}
        />
      </InputArea>

      <InputArea $area="salaryGroups">
        <label>{translations.salaryGroups}</label>
        <SalaryGroupCombobox
          mode="multiple"
          value={salaryGroups}
          disabled={disabled}
          onChange={salaryGroups => onUpdateForm({ salaryGroups })}
        />
      </InputArea>
    </>
  )
}
